export const Prizes = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1119.262"
    height="373.246"
    viewBox="0 0 1119.262 373.246"
  >
    <defs>
      <linearGradient
        id="linear-gradient"
        x1="0.224"
        y1="0.471"
        x2="1"
        y2="0.481"
        gradientUnits="objectBoundingBox"
      >
        <stop offset="0" stopColor="#161622" />
        <stop offset="1" stopColor="#20232a" />
      </linearGradient>
      <linearGradient
        id="linear-gradient-2"
        x1="0.224"
        y1="0.471"
        x2="1"
        y2="0.481"
        gradientUnits="objectBoundingBox"
      >
        <stop offset="0" stopColor="#161622" />
        <stop offset="1" stopColor="#232537" />
      </linearGradient>
      <linearGradient
        id="linear-gradient-3"
        x1="0.224"
        y1="0.471"
        x2="1"
        y2="0.481"
        gradientUnits="objectBoundingBox"
      >
        <stop offset="0" stopColor="#161622" />
        <stop offset="1" stopColor="#1f1c2f" />
      </linearGradient>
      <linearGradient
        id="linear-gradient-4"
        x1="0.224"
        y1="0.471"
        x2="1"
        y2="0.481"
        gradientUnits="objectBoundingBox"
      >
        <stop offset="0" stopColor="#161622" />
        <stop offset="1" stopColor="#23203c" />
      </linearGradient>
      <linearGradient
        id="linear-gradient-5"
        x1="0.224"
        y1="0.471"
        x2="1"
        y2="0.481"
        gradientUnits="objectBoundingBox"
      >
        <stop offset="0" stopColor="#161622" />
        <stop offset="1" stopColor="#291e28" />
      </linearGradient>
    </defs>
    <g
      id="Group_12399"
      data-name="Group 12399"
      transform="translate(-159.134 -2914.264)"
    >
      <g
        id="Rectangle_7359"
        data-name="Rectangle 7359"
        transform="translate(371.083 3105.678) rotate(90)"
        stroke="#223"
        strokeWidth="1"
        fill="url(#linear-gradient)"
      >
        <rect
          width="181.813"
          height="211.949"
          stroke="none"
          className="prizes-animated"
        />
      </g>
      <g
        id="Group_12392"
        data-name="Group 12392"
        transform="translate(-726.268 295.223)"
        className="prizes-animated2"
      >
        <g
          id="Group_12385"
          data-name="Group 12385"
          transform="translate(953.605 2847.354)"
        >
          <path
            id="Path_49079"
            data-name="Path 49079"
            d="M261.514,256.686l9.944-5.094,6.065,9.384,11.159.56.56,11.159,9.384,6.065-5.094,9.944,5.094,9.944-9.384,6.065-.56,11.159-11.159.56-6.065,9.384-9.944-5.094-9.944,5.094-6.065-9.384-11.159-.56-.56-11.159-9.384-6.065L229.5,288.7,224.4,278.76l9.384-6.065.56-11.159,11.159-.56,6.065-9.384Z"
            transform="translate(-224.402 -251.592)"
            fill="#2c2a43"
          />
          <path
            id="Path_49080"
            data-name="Path 49080"
            d="M255.719,255.891l8.391-4.3,5.118,7.919,9.417.473.473,9.417,7.919,5.118-4.3,8.391,4.3,8.391-7.919,5.118-.473,9.417-9.417.473-5.118,7.919-8.391-4.3-8.391,4.3-5.118-7.919-9.417-.473-.473-9.417L224.4,291.3l4.3-8.391-4.3-8.391,7.919-5.118.473-9.417,9.417-.473,5.118-7.919Z"
            transform="translate(-218.607 -245.797)"
            fill="#3a3757"
          />
          <path
            id="Path_49081"
            data-name="Path 49081"
            d="M253.415,255.575l7.774-3.983,4.741,7.336,8.724.438.438,8.724,7.336,4.741-3.983,7.774,3.983,7.774-7.336,4.741-.438,8.724-8.724.438-4.741,7.336-7.774-3.983-7.774,3.983-4.741-7.336-8.724-.438-.438-8.724-7.336-4.741,3.983-7.774-3.983-7.774,7.336-4.741.438-8.724,8.724-.438,4.741-7.336Z"
            transform="translate(-216.303 -243.492)"
            fill="#211f33"
          />
        </g>
        <path
          id="Path_49089"
          data-name="Path 49089"
          d="M10.84-8.877H6.749V-13.53H2.722v4.653H-4.834L5.891-23.1H1.3L-10.082-8.217v2.97H2.591V0H6.749V-5.247H10.84Z"
          transform="translate(990.318 2896.263)"
          fill="#718d6f"
        />
      </g>
      <g
        id="Rectangle_7353"
        data-name="Rectangle 7353"
        transform="translate(581.161 3005.678) rotate(90)"
        stroke="#223"
        strokeWidth="1"
        fill="url(#linear-gradient-2)"
      >
        <rect
          width="281.831"
          height="211.949"
          stroke="none"
          className="prizes-animated"
        />
      </g>
      <path
        id="Path_49156"
        data-name="Path 49156"
        d="M.144-12.6v1.962H2.808V0h2.34V-12.6ZM10.836-1.98l3.366-3.2c1.746-1.638,2.088-2.754,2.088-3.978,0-2.232-1.764-3.618-4.5-3.618A5.819,5.819,0,0,0,7-10.692L8.64-9.432a3.556,3.556,0,0,1,2.952-1.314c1.548,0,2.34.666,2.34,1.818,0,.7-.216,1.44-1.44,2.61l-5,4.752V0h9.288V-1.98ZM19.71.126a1.464,1.464,0,0,0,1.476-1.494A1.442,1.442,0,0,0,19.71-2.862a1.442,1.442,0,0,0-1.476,1.494A1.464,1.464,0,0,0,19.71.126ZM27.738.18c3.006,0,5.274-2.34,5.274-6.48s-2.268-6.48-5.274-6.48c-2.988,0-5.256,2.34-5.256,6.48S24.75.18,27.738.18Zm0-2.034c-1.71,0-2.9-1.4-2.9-4.446s1.188-4.446,2.9-4.446c1.728,0,2.916,1.4,2.916,4.446S29.466-1.854,27.738-1.854ZM39.852.18c3.006,0,5.274-2.34,5.274-6.48s-2.268-6.48-5.274-6.48c-2.988,0-5.256,2.34-5.256,6.48S36.864.18,39.852.18Zm0-2.034c-1.71,0-2.9-1.4-2.9-4.446s1.188-4.446,2.9-4.446c1.728,0,2.916,1.4,2.916,4.446S41.58-1.854,39.852-1.854ZM51.966.18c3.006,0,5.274-2.34,5.274-6.48s-2.268-6.48-5.274-6.48c-2.988,0-5.256,2.34-5.256,6.48S48.978.18,51.966.18Zm0-2.034c-1.71,0-2.9-1.4-2.9-4.446s1.188-4.446,2.9-4.446c1.728,0,2.916,1.4,2.916,4.446S53.694-1.854,51.966-1.854ZM70.47-6.39H68.148c0,2.79-1.512,4.428-4.608,4.428h-.774V-5.778l4.59-2.43V-9.522L62.766-7.11V-8.352l4.59-2.412V-12.1l-4.59,2.43V-12.6h-2.3v4.14l-1.89,1.008v1.314l1.89-.99v1.242l-1.89.99v1.332l1.89-1.008V0h2.574C67.968,0,70.488-2.412,70.47-6.39Z"
        transform="translate(443 3221)"
        fill="#a2a5d3"
        className="prizes-animated3"
      />
      <g
        id="Group_12390"
        data-name="Group 12390"
        transform="translate(-513.946 212.93)"
        className="prizes-animated2"
      >
        <path
          id="Path_49086"
          data-name="Path 49086"
          d="M26.788,56.291,37.164,6.771l-14.94,8.205L10.253,0,0,49.767Z"
          transform="translate(992.184 2961.015) rotate(-173)"
          fill="#656d9d"
        />
        <path
          id="Path_49085"
          data-name="Path 49085"
          d="M26.787,0,37.164,49.52l-14.94-8.205L10.253,56.29,0,6.523Z"
          transform="translate(980.913 2905.92) rotate(-7)"
          fill="#4f5681"
        />
        <path
          id="Path_49088"
          data-name="Path 49088"
          d="M-14195.965-20009.426l5.082-2.406,10.061,4.93,6.67-10.082,4.6-.371-1.637-4.447h-5.078l-5.525,8-9.09-4.207-6.8,3.615Z"
          transform="translate(15179.786 22928.029)"
          fill="#454c74"
        />
        <path
          id="Path_49087"
          data-name="Path 49087"
          d="M-14199.71-20010.437l-5.585,2.617-5.586-8.98-3.566-.445,1.661-5.465h4.213l5.223,9.158,2.27-1.137Z"
          transform="translate(15183.536 22929.008)"
          fill="#5a618d"
        />
        <g
          id="Group_12385-2"
          data-name="Group 12385"
          transform="translate(953.605 2847.354)"
        >
          <path
            id="Path_49079-2"
            data-name="Path 49079"
            d="M259.575,256.42,269,251.592l5.748,8.894,10.576.531.531,10.576,8.894,5.748-4.828,9.425,4.828,9.425-8.894,5.748-.531,10.576-10.576.531L269,321.938l-9.425-4.828-9.425,4.828-5.748-8.894-10.576-.531-.531-10.576L224.4,296.19l4.828-9.425-4.828-9.425,8.894-5.748.531-10.576,10.576-.531,5.748-8.894Z"
            transform="translate(-224.402 -251.592)"
            fill="#2c2a43"
          />
          <path
            id="Path_49080-2"
            data-name="Path 49080"
            d="M254.083,255.666l7.953-4.074,4.85,7.505,8.925.448.448,8.925,7.505,4.85-4.074,7.953,4.074,7.953-7.505,4.85L275.812,303l-8.925.448-4.85,7.505-7.953-4.074-7.953,4.074-4.85-7.505L232.355,303l-.448-8.925-7.505-4.85,4.074-7.953L224.4,273.32l7.505-4.85.448-8.925,8.925-.448,4.85-7.505Z"
            transform="translate(-218.91 -246.099)"
            fill="#3a3757"
          />
          <path
            id="Path_49081-2"
            data-name="Path 49081"
            d="M251.9,255.367l7.368-3.775,4.494,6.953,8.268.415.415,8.268,6.953,4.493-3.775,7.368,3.775,7.368-6.953,4.494-.415,8.268-8.268.415-4.494,6.953-7.368-3.775-7.368,3.775-4.494-6.953-8.268-.415-.415-8.268-6.953-4.494,3.775-7.368-3.775-7.368,6.953-4.493.415-8.268,8.268-.415,4.494-6.953Z"
            transform="translate(-216.726 -243.915)"
            fill="#211f33"
          />
        </g>
        <path
          id="Path_49090"
          data-name="Path 49090"
          d="M-2.17-3.41l5.8-5.518c3.007-2.821,3.6-4.743,3.6-6.851,0-3.844-3.038-6.231-7.75-6.231-3.565,0-6.572,1.333-8.246,3.6l2.821,2.17A6.125,6.125,0,0,1-.868-18.507c2.666,0,4.03,1.147,4.03,3.131,0,1.209-.372,2.48-2.48,4.495L-7.936-2.7V0h16V-3.41Z"
          transform="translate(988.528 2893.38)"
          fill="#a2a5d3"
        />
      </g>
      <g
        id="Rectangle_7360"
        data-name="Rectangle 7360"
        transform="translate(1278.396 3105.695) rotate(90)"
        stroke="#223"
        strokeWidth="1"
        fill="url(#linear-gradient-3)"
      >
        <rect
          className="prizes-animated"
          width="181.813"
          height="211.949"
          stroke="none"
        />
      </g>
      <g
        id="Rectangle_7358"
        data-name="Rectangle 7358"
        transform="translate(857.627 2914.264) rotate(90)"
        stroke="#223"
        strokeWidth="1"
        fill="url(#linear-gradient-4)"
      >
        <rect
          width="373.246"
          height="277.261"
          stroke="none"
          className="prizes-animated"
        />
      </g>
      <g
        id="Rectangle_7354"
        data-name="Rectangle 7354"
        transform="translate(1068.447 3005.678) rotate(90)"
        stroke="#223"
        strokeWidth="1"
        fill="url(#linear-gradient-5)"
      >
        <rect
          width="281.831"
          height="211.949"
          stroke="none"
          className="prizes-animated"
        />
      </g>
      <path
        id="Path_49157"
        data-name="Path 49157"
        d="M5.3-2.64,9.792-6.912c2.328-2.184,2.784-3.672,2.784-5.3,0-2.976-2.352-4.824-6-4.824A7.758,7.758,0,0,0,.192-14.256l2.184,1.68a4.742,4.742,0,0,1,3.936-1.752c2.064,0,3.12.888,3.12,2.424,0,.936-.288,1.92-1.92,3.48L.84-2.088V0H13.224V-2.64ZM29.64-6.456H26.664V-9.84H23.736v3.384h-5.5L26.04-16.8H22.7L14.424-5.976v2.16H23.64V0h3.024V-3.816H29.64ZM33.312.168A1.952,1.952,0,0,0,35.28-1.824a1.923,1.923,0,0,0-1.968-1.992,1.923,1.923,0,0,0-1.968,1.992A1.952,1.952,0,0,0,33.312.168Zm10.7.072c4.008,0,7.032-3.12,7.032-8.64s-3.024-8.64-7.032-8.64c-3.984,0-7.008,3.12-7.008,8.64S40.032.24,44.016.24Zm0-2.712c-2.28,0-3.864-1.872-3.864-5.928s1.584-5.928,3.864-5.928c2.3,0,3.888,1.872,3.888,5.928S46.32-2.472,44.016-2.472ZM60.168.24C64.176.24,67.2-2.88,67.2-8.4s-3.024-8.64-7.032-8.64c-3.984,0-7.008,3.12-7.008,8.64S56.184.24,60.168.24Zm0-2.712c-2.28,0-3.864-1.872-3.864-5.928s1.584-5.928,3.864-5.928c2.3,0,3.888,1.872,3.888,5.928S62.472-2.472,60.168-2.472ZM76.32.24c4.008,0,7.032-3.12,7.032-8.64s-3.024-8.64-7.032-8.64c-3.984,0-7.008,3.12-7.008,8.64S72.336.24,76.32.24Zm0-2.712c-2.28,0-3.864-1.872-3.864-5.928s1.584-5.928,3.864-5.928c2.3,0,3.888,1.872,3.888,5.928S78.624-2.472,76.32-2.472ZM100.992-8.52H97.9c0,3.72-2.016,5.9-6.144,5.9H90.72V-7.7l6.12-3.24V-12.7L90.72-9.48v-1.656l6.12-3.216v-1.776l-6.12,3.24V-16.8H87.648v5.52l-2.52,1.344v1.752l2.52-1.32v1.656l-2.52,1.32v1.776L87.648-6.1V0H91.08C97.656,0,101.016-3.216,100.992-8.52Z"
        transform="translate(669 3219)"
        fill="#e8b064"
        className="prizes-animated3"
      />
      <g
        id="Group_12090"
        data-name="Group 12090"
        transform="translate(33.125 -212)"
        opacity="0.505"
      >
        <path
          id="Path_49082"
          data-name="Path 49082"
          className="decoration-animated"
          d="M-14515.347-19974.176l6.3-6.3-6.3-6.3,4.772-4.773-7.083-7.082"
          transform="matrix(0.891, 0.454, -0.454, 0.891, 4547.895, 27599.146)"
          fill="none"
          stroke="#e8b064"
          strokeWidth="3"
        />
        <path
          id="Path_49083"
          data-name="Path 49083"
          className="decoration-animated"
          d="M1.747,18.5,6.514,13.73,1.747,8.965,5.357,5.355,0,0"
          transform="matrix(-0.602, -0.799, 0.799, -0.602, 720.927, 3223.477)"
          fill="none"
          stroke="#e8b064"
          strokeWidth="3"
        />
        <path
          id="Path_49084"
          data-name="Path 49084"
          className="decoration-animated"
          d="M1.746,0,6.513,4.768,1.747,9.533l3.609,3.61L0,18.5"
          transform="matrix(0.602, -0.799, 0.799, 0.602, 641.383, 3212.344)"
          fill="none"
          stroke="#e8b064"
          strokeWidth="3"
        />
      </g>
      <g
        id="Group_12385-3"
        data-name="Group 12385"
        transform="translate(-279.374 167.813)"
        className="prizes-animated2"
      >
        <path
          id="Path_49086-2"
          data-name="Path 49086"
          d="M34.509,72.518,47.876,8.723,28.63,19.293,13.208,0,0,64.113Z"
          transform="translate(1003.304 2993.779) rotate(-173)"
          fill="#463d79"
        />
        <path
          id="Path_49085-2"
          data-name="Path 49085"
          d="M-14438.466-19854.387l13.367,63.795-19.246-10.57-15.422,19.293-13.209-64.113Z"
          transform="translate(17773.521 20865.385) rotate(-7)"
          fill="#39306c"
        />
        <path
          id="Path_49088-2"
          data-name="Path 49088"
          d="M-14195.469-20005.857l6.548-3.1,12.96,6.35,8.593-12.988,5.925-.477-2.108-5.73h-6.542l-7.118,10.3-11.709-5.422-8.765,4.658Z"
          transform="translate(15188 22945)"
          fill="#28214d"
        />
        <path
          id="Path_49087-2"
          data-name="Path 49087"
          d="M-14195.462-20006.9l-7.2,3.373-7.2-11.57-4.595-.572,2.141-7.041h5.427l6.728,11.8,2.924-1.463Z"
          transform="translate(15188 22946)"
          fill="#3e366a"
        />
        <g id="Group_12385-4" data-name="Group 12385">
          <path
            id="Path_49079-3"
            data-name="Path 49079"
            d="M269.714,257.812l12.141-6.22,7.4,11.457,13.625.684.684,13.625,11.457,7.4-6.22,12.141,6.22,12.141-11.457,7.4-.684,13.625-13.625.684-7.4,11.457L269.714,336l-12.141,6.22-7.4-11.457-13.625-.684-.684-13.625-11.457-7.4,6.22-12.141-6.22-12.141,11.457-7.4.684-13.625,13.625-.684,7.4-11.457Z"
            transform="translate(729.203 2595.762)"
            fill="#2c2a43"
          />
          <path
            id="Path_49080-3"
            data-name="Path 49080"
            d="M262.639,256.841l10.246-5.249,6.249,9.668,11.5.577.577,11.5,9.668,6.249-5.249,10.246,5.249,10.246-9.668,6.249-.577,11.5-11.5.577-6.249,9.668-10.246-5.249-10.246,5.249-6.249-9.668-11.5-.577-.577-11.5-9.668-6.249,5.249-10.246L224.4,279.584l9.668-6.249.577-11.5,11.5-.577,6.249-9.668Z"
            transform="translate(736.278 2602.838)"
            fill="#3a3757"
          />
          <path
            id="Path_49081-3"
            data-name="Path 49081"
            d="M259.826,256.455l9.492-4.863,5.789,8.957,10.652.535.535,10.652,8.957,5.789-4.863,9.492,4.863,9.492-8.957,5.789-.535,10.651-10.652.535-5.789,8.957-9.492-4.863-9.492,4.863-5.789-8.957-10.652-.535-.535-10.651-8.957-5.789,4.863-9.492-4.863-9.492,8.957-5.789.535-10.652,10.652-.535,5.789-8.957Z"
            transform="translate(739.091 2605.652)"
            fill="#211f33"
          />
        </g>
        <path
          id="Path_49091"
          data-name="Path 49091"
          d="M-7.3-28v4.36h5.92V0h5.2V-28Z"
          transform="translate(999 2907)"
          fill="#e8b064"
        />
      </g>
      <g
        id="Group_12391"
        data-name="Group 12391"
        transform="translate(-26.66 212.109)"
        className="prizes-animated2"
      >
        <path
          id="Path_49086-3"
          data-name="Path 49086"
          d="M26.788,56.291,37.164,6.771l-14.94,8.205L10.253,0,0,49.767Z"
          transform="translate(992.184 2961.015) rotate(-173)"
          fill="#a2615f"
        />
        <path
          id="Path_49085-3"
          data-name="Path 49085"
          d="M26.787,0,37.164,49.52l-14.94-8.205L10.253,56.29,0,6.523Z"
          transform="translate(980.913 2905.92) rotate(-7)"
          fill="#894b49"
        />
        <path
          id="Path_49088-3"
          data-name="Path 49088"
          d="M-14195.965-20009.426l5.082-2.406,10.061,4.93,6.67-10.082,4.6-.371-1.637-4.447h-5.078l-5.525,8-9.09-4.207-6.8,3.615Z"
          transform="translate(15179.786 22928.029)"
          fill="#773c3a"
        />
        <path
          id="Path_49087-3"
          data-name="Path 49087"
          d="M-14199.71-20010.437l-5.585,2.617-5.586-8.98-3.566-.445,1.661-5.465h4.213l5.223,9.158,2.27-1.137Z"
          transform="translate(15183.536 22929.008)"
          fill="#8d4f4d"
        />
        <g
          id="Group_12385-5"
          data-name="Group 12385"
          transform="translate(953.605 2847.354)"
        >
          <path
            id="Path_49079-4"
            data-name="Path 49079"
            d="M259.575,256.42,269,251.592l5.748,8.894,10.576.531.531,10.576,8.894,5.748-4.828,9.425,4.828,9.425-8.894,5.748-.531,10.576-10.576.531L269,321.938l-9.425-4.828-9.425,4.828-5.748-8.894-10.576-.531-.531-10.576L224.4,296.19l4.828-9.425-4.828-9.425,8.894-5.748.531-10.576,10.576-.531,5.748-8.894Z"
            transform="translate(-224.402 -251.592)"
            fill="#2c2a43"
          />
          <path
            id="Path_49080-4"
            data-name="Path 49080"
            d="M254.083,255.666l7.953-4.074,4.85,7.505,8.925.448.448,8.925,7.505,4.85-4.074,7.953,4.074,7.953-7.505,4.85L275.812,303l-8.925.448-4.85,7.505-7.953-4.074-7.953,4.074-4.85-7.505L232.355,303l-.448-8.925-7.505-4.85,4.074-7.953L224.4,273.32l7.505-4.85.448-8.925,8.925-.448,4.85-7.505Z"
            transform="translate(-218.91 -246.099)"
            fill="#3a3757"
          />
          <path
            id="Path_49081-4"
            data-name="Path 49081"
            d="M251.9,255.367l7.368-3.775,4.494,6.953,8.268.415.415,8.268,6.953,4.493-3.775,7.368,3.775,7.368-6.953,4.494-.415,8.268-8.268.415-4.494,6.953-7.368-3.775-7.368,3.775-4.494-6.953-8.268-.415-.415-8.268-6.953-4.494,3.775-7.368-3.775-7.368,6.953-4.493.415-8.268,8.268-.415,4.494-6.953Z"
            transform="translate(-216.726 -243.915)"
            fill="#211f33"
          />
        </g>
        <path
          id="Path_49092"
          data-name="Path 49092"
          d="M1.581-12.741,6.851-19v-2.7H-7.936v3.379H1.922l-4.929,5.859V-9.7h1.984c3.286,0,4.712,1.271,4.712,3.224,0,2.015-1.7,3.286-4.588,3.286A10.118,10.118,0,0,1-7.254-5.332L-8.99-2.2A13.633,13.633,0,0,0-.837.31C4.991.31,7.75-2.852,7.75-6.51,7.75-9.765,5.673-12.214,1.581-12.741Z"
          transform="translate(988.528 2893.38)"
          fill="#a2615f"
        />
      </g>
      <g
        id="Group_12393"
        data-name="Group 12393"
        transform="translate(182.385 297.145)"
        className="prizes-animated2"
      >
        <g
          id="Group_12385-6"
          data-name="Group 12385"
          transform="translate(953.605 2847.354)"
        >
          <path
            id="Path_49079-5"
            data-name="Path 49079"
            d="M261.514,256.686l9.944-5.094,6.065,9.384,11.159.56.56,11.159,9.384,6.065-5.094,9.944,5.094,9.944-9.384,6.065-.56,11.159-11.159.56-6.065,9.384-9.944-5.094-9.944,5.094-6.065-9.384-11.159-.56-.56-11.159-9.384-6.065L229.5,288.7,224.4,278.76l9.384-6.065.56-11.159,11.159-.56,6.065-9.384Z"
            transform="translate(-224.402 -251.592)"
            fill="#2c2a43"
          />
          <path
            id="Path_49080-5"
            data-name="Path 49080"
            d="M255.719,255.891l8.391-4.3,5.118,7.919,9.417.473.473,9.417,7.919,5.118-4.3,8.391,4.3,8.391-7.919,5.118-.473,9.417-9.417.473-5.118,7.919-8.391-4.3-8.391,4.3-5.118-7.919-9.417-.473-.473-9.417L224.4,291.3l4.3-8.391-4.3-8.391,7.919-5.118.473-9.417,9.417-.473,5.118-7.919Z"
            transform="translate(-218.607 -245.797)"
            fill="#3a3757"
          />
          <path
            id="Path_49081-5"
            data-name="Path 49081"
            d="M253.415,255.575l7.774-3.983,4.741,7.336,8.724.438.438,8.724,7.336,4.741-3.983,7.774,3.983,7.774-7.336,4.741-.438,8.724-8.724.438-4.741,7.336-7.774-3.983-7.774,3.983-4.741-7.336-8.724-.438-.438-8.724-7.336-4.741,3.983-7.774-3.983-7.774,7.336-4.741.438-8.724,8.724-.438,4.741-7.336Z"
            transform="translate(-216.303 -243.492)"
            fill="#211f33"
          />
        </g>
        <path
          id="Path_49093"
          data-name="Path 49093"
          d="M-.957-14.157H-3.168l.495-5.346H7.26v-3.6H-6.3L-7.491-10.527h5.577c4.785,0,6.2,1.386,6.2,3.6C4.29-4.752,2.475-3.4-.594-3.4a10.937,10.937,0,0,1-6.8-2.277L-9.207-2.343A14.44,14.44,0,0,0-.528.33c6.2,0,9.141-3.366,9.141-7.425C8.613-11.187,5.874-14.157-.957-14.157Z"
          transform="translate(990.318 2896.263)"
          fill="#8e72db"
        />
      </g>
      <path
        id="Path_49158"
        data-name="Path 49158"
        d="M6.516-7.776A4.3,4.3,0,0,0,3.15-6.462V-6.48c0-2.862,1.494-4.338,3.87-4.338a4.285,4.285,0,0,1,2.394.612l.864-1.764a6.316,6.316,0,0,0-3.312-.81C3.312-12.78.792-10.4.792-6.084.792-2.034,2.808.18,6.246.18,8.82.18,10.854-1.4,10.854-3.906,10.854-6.264,9-7.776,6.516-7.776Zm-.4,6.12c-1.674,0-2.61-.936-2.61-2.124A2.292,2.292,0,0,1,6.066-5.94c1.53,0,2.52.828,2.52,2.142A2.187,2.187,0,0,1,6.12-1.656ZM13.662.126a1.464,1.464,0,0,0,1.476-1.494,1.442,1.442,0,0,0-1.476-1.494,1.442,1.442,0,0,0-1.476,1.494A1.464,1.464,0,0,0,13.662.126ZM21.69.18c3.006,0,5.274-2.34,5.274-6.48S24.7-12.78,21.69-12.78c-2.988,0-5.256,2.34-5.256,6.48S18.7.18,21.69.18Zm0-2.034c-1.71,0-2.9-1.4-2.9-4.446s1.188-4.446,2.9-4.446c1.728,0,2.916,1.4,2.916,4.446S23.418-1.854,21.69-1.854ZM33.8.18c3.006,0,5.274-2.34,5.274-6.48S36.81-12.78,33.8-12.78c-2.988,0-5.256,2.34-5.256,6.48S30.816.18,33.8.18Zm0-2.034c-1.71,0-2.9-1.4-2.9-4.446s1.188-4.446,2.9-4.446c1.728,0,2.916,1.4,2.916,4.446S35.532-1.854,33.8-1.854ZM45.918.18c3.006,0,5.274-2.34,5.274-6.48s-2.268-6.48-5.274-6.48c-2.988,0-5.256,2.34-5.256,6.48S42.93.18,45.918.18Zm0-2.034c-1.71,0-2.9-1.4-2.9-4.446s1.188-4.446,2.9-4.446c1.728,0,2.916,1.4,2.916,4.446S47.646-1.854,45.918-1.854Zm18.5-4.536H62.1c0,2.79-1.512,4.428-4.608,4.428h-.774V-5.778l4.59-2.43V-9.522L56.718-7.11V-8.352l4.59-2.412V-12.1l-4.59,2.43V-12.6h-2.3v4.14l-1.89,1.008v1.314l1.89-.99v1.242l-1.89.99v1.332l1.89-1.008V0h2.574C61.92,0,64.44-2.412,64.422-6.39Z"
        transform="translate(930 3217)"
        fill="#a2615f"
        className="prizes-animated3"
      />
      <path
        id="Path_49155"
        data-name="Path 49155"
        d="M10.688-4.3H8.7V-6.56H6.752V-4.3H3.088l5.2-6.9H6.064L.544-3.984v1.44H6.688V0H8.7V-2.544h1.984ZM13.136.112a1.3,1.3,0,0,0,1.312-1.328,1.282,1.282,0,0,0-1.312-1.328,1.282,1.282,0,0,0-1.312,1.328A1.3,1.3,0,0,0,13.136.112ZM20.272.16c2.672,0,4.688-2.08,4.688-5.76s-2.016-5.76-4.688-5.76c-2.656,0-4.672,2.08-4.672,5.76S17.616.16,20.272.16Zm0-1.808C18.752-1.648,17.7-2.9,17.7-5.6s1.056-3.952,2.576-3.952c1.536,0,2.592,1.248,2.592,3.952S21.808-1.648,20.272-1.648ZM31.04.16c2.672,0,4.688-2.08,4.688-5.76s-2.016-5.76-4.688-5.76c-2.656,0-4.672,2.08-4.672,5.76S28.384.16,31.04.16Zm0-1.808c-1.52,0-2.576-1.248-2.576-3.952S29.52-9.552,31.04-9.552c1.536,0,2.592,1.248,2.592,3.952S32.576-1.648,31.04-1.648ZM41.808.16C44.48.16,46.5-1.92,46.5-5.6s-2.016-5.76-4.688-5.76c-2.656,0-4.672,2.08-4.672,5.76S39.152.16,41.808.16Zm0-1.808c-1.52,0-2.576-1.248-2.576-3.952s1.056-3.952,2.576-3.952C43.344-9.552,44.4-8.3,44.4-5.6S43.344-1.648,41.808-1.648ZM58.256-5.68H56.192c0,2.48-1.344,3.936-4.1,3.936h-.688V-5.136l4.08-2.16V-8.464L51.408-6.32v-1.1l4.08-2.144v-1.184l-4.08,2.16V-11.2H49.36v3.68l-1.68.9v1.168l1.68-.88v1.1l-1.68.88v1.184l1.68-.9V0h2.288C56.032,0,58.272-2.144,58.256-5.68Z"
        transform="translate(234 3249)"
        fill="#718d6f"
        className="prizes-animated3"
      />
      <path
        id="Path_49159"
        data-name="Path 49159"
        d="M5.472-6.576l2.72-3.232V-11.2H.56v1.744H5.648L3.1-6.432v1.424H4.128c1.7,0,2.432.656,2.432,1.664,0,1.04-.88,1.7-2.368,1.7a5.222,5.222,0,0,1-3.28-1.1l-.9,1.616A7.036,7.036,0,0,0,4.224.16c3.008,0,4.432-1.632,4.432-3.52C8.656-5.04,7.584-6.3,5.472-6.576ZM11.264.112a1.3,1.3,0,0,0,1.312-1.328,1.282,1.282,0,0,0-1.312-1.328A1.282,1.282,0,0,0,9.952-1.216,1.3,1.3,0,0,0,11.264.112ZM18.4.16c2.672,0,4.688-2.08,4.688-5.76s-2.016-5.76-4.688-5.76c-2.656,0-4.672,2.08-4.672,5.76S15.744.16,18.4.16Zm0-1.808c-1.52,0-2.576-1.248-2.576-3.952S16.88-9.552,18.4-9.552c1.536,0,2.592,1.248,2.592,3.952S19.936-1.648,18.4-1.648ZM29.168.16c2.672,0,4.688-2.08,4.688-5.76s-2.016-5.76-4.688-5.76c-2.656,0-4.672,2.08-4.672,5.76S26.512.16,29.168.16Zm0-1.808c-1.52,0-2.576-1.248-2.576-3.952s1.056-3.952,2.576-3.952C30.7-9.552,31.76-8.3,31.76-5.6S30.7-1.648,29.168-1.648ZM39.936.16c2.672,0,4.688-2.08,4.688-5.76s-2.016-5.76-4.688-5.76c-2.656,0-4.672,2.08-4.672,5.76S37.28.16,39.936.16Zm0-1.808c-1.52,0-2.576-1.248-2.576-3.952s1.056-3.952,2.576-3.952c1.536,0,2.592,1.248,2.592,3.952S41.472-1.648,39.936-1.648ZM56.384-5.68H54.32c0,2.48-1.344,3.936-4.1,3.936h-.688V-5.136l4.08-2.16V-8.464L49.536-6.32v-1.1l4.08-2.144v-1.184l-4.08,2.16V-11.2H47.488v3.68l-1.68.9v1.168l1.68-.88v1.1l-1.68.88v1.184l1.68-.9V0h2.288C54.16,0,56.4-2.144,56.384-5.68Z"
        transform="translate(1145 3249)"
        fill="#8e72db"
        className="prizes-animated3"
      />
    </g>
  </svg>
);

export const Prizes_ = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1119.262"
    height="373.246"
    viewBox="0 0 1119.262 373.246"
  >
    <defs>
      <linearGradient
        id="linear-gradient"
        x1="0.224"
        y1="0.471"
        x2="1"
        y2="0.481"
        gradientUnits="objectBoundingBox"
      >
        <stop offset="0" stop-color="#161622" />
        <stop offset="1" stop-color="#20232a" />
      </linearGradient>
      <linearGradient
        id="linear-gradient-2"
        x1="0.224"
        y1="0.471"
        x2="1"
        y2="0.481"
        gradientUnits="objectBoundingBox"
      >
        <stop offset="0" stop-color="#161622" />
        <stop offset="1" stop-color="#232537" />
      </linearGradient>
      <linearGradient
        id="linear-gradient-3"
        x1="0.224"
        y1="0.471"
        x2="1"
        y2="0.481"
        gradientUnits="objectBoundingBox"
      >
        <stop offset="0" stop-color="#161622" />
        <stop offset="1" stop-color="#1f1c2f" />
      </linearGradient>
      <linearGradient
        id="linear-gradient-4"
        x1="0.224"
        y1="0.471"
        x2="1"
        y2="0.481"
        gradientUnits="objectBoundingBox"
      >
        <stop offset="0" stop-color="#161622" />
        <stop offset="1" stop-color="#23203c" />
      </linearGradient>
      <linearGradient
        id="linear-gradient-5"
        x1="0.224"
        y1="0.471"
        x2="1"
        y2="0.481"
        gradientUnits="objectBoundingBox"
      >
        <stop offset="0" stop-color="#161622" />
        <stop offset="1" stop-color="#291e28" />
      </linearGradient>
    </defs>
    <g
      id="Group_12413"
      data-name="Group 12413"
      transform="translate(-159.134 -2914.264)"
    >
      <rect
        id="Rectangle_7359"
        data-name="Rectangle 7359"
        width="181.813"
        height="211.949"
        transform="translate(371.083 3105.678) rotate(90)"
        fill="url(#linear-gradient)"
      />
      <g
        id="Group_12392"
        data-name="Group 12392"
        transform="translate(-726.268 295.223)"
      >
        <g
          id="Group_12385"
          data-name="Group 12385"
          transform="translate(953.605 2847.354)"
        >
          <path
            id="Path_49079"
            data-name="Path 49079"
            d="M261.514,256.686l9.944-5.094,6.065,9.384,11.159.56.56,11.159,9.384,6.065-5.094,9.944,5.094,9.944-9.384,6.065-.56,11.159-11.159.56-6.065,9.384-9.944-5.094-9.944,5.094-6.065-9.384-11.159-.56-.56-11.159-9.384-6.065L229.5,288.7,224.4,278.76l9.384-6.065.56-11.159,11.159-.56,6.065-9.384Z"
            transform="translate(-224.402 -251.592)"
            fill="#2c2a43"
          />
          <path
            id="Path_49080"
            data-name="Path 49080"
            d="M255.719,255.891l8.391-4.3,5.118,7.919,9.417.473.473,9.417,7.919,5.118-4.3,8.391,4.3,8.391-7.919,5.118-.473,9.417-9.417.473-5.118,7.919-8.391-4.3-8.391,4.3-5.118-7.919-9.417-.473-.473-9.417L224.4,291.3l4.3-8.391-4.3-8.391,7.919-5.118.473-9.417,9.417-.473,5.118-7.919Z"
            transform="translate(-218.607 -245.797)"
            fill="#3a3757"
          />
          <path
            id="Path_49081"
            data-name="Path 49081"
            d="M253.415,255.575l7.774-3.983,4.741,7.336,8.724.438.438,8.724,7.336,4.741-3.983,7.774,3.983,7.774-7.336,4.741-.438,8.724-8.724.438-4.741,7.336-7.774-3.983-7.774,3.983-4.741-7.336-8.724-.438-.438-8.724-7.336-4.741,3.983-7.774-3.983-7.774,7.336-4.741.438-8.724,8.724-.438,4.741-7.336Z"
            transform="translate(-216.303 -243.492)"
            fill="#211f33"
          />
        </g>
        <path
          id="Path_49089"
          data-name="Path 49089"
          d="M10.84-8.877H6.749V-13.53H2.722v4.653H-4.834L5.891-23.1H1.3L-10.082-8.217v2.97H2.591V0H6.749V-5.247H10.84Z"
          transform="translate(990.318 2896.263)"
          fill="#718d6f"
        />
      </g>
      <rect
        id="Rectangle_7353"
        data-name="Rectangle 7353"
        width="281.831"
        height="211.949"
        transform="translate(581.161 3005.678) rotate(90)"
        fill="url(#linear-gradient-2)"
      />
      <g
        id="Group_12390"
        data-name="Group 12390"
        transform="translate(-513.946 212.93)"
      >
        <path
          id="Path_49086"
          data-name="Path 49086"
          d="M26.788,56.291,37.164,6.771l-14.94,8.205L10.253,0,0,49.767Z"
          transform="translate(992.184 2961.015) rotate(-173)"
          fill="#656d9d"
        />
        <path
          id="Path_49085"
          data-name="Path 49085"
          d="M26.787,0,37.164,49.52l-14.94-8.205L10.253,56.29,0,6.523Z"
          transform="translate(980.913 2905.92) rotate(-7)"
          fill="#4f5681"
        />
        <path
          id="Path_49088"
          data-name="Path 49088"
          d="M-14195.965-20009.426l5.082-2.406,10.061,4.93,6.67-10.082,4.6-.371-1.637-4.447h-5.078l-5.525,8-9.09-4.207-6.8,3.615Z"
          transform="translate(15179.786 22928.029)"
          fill="#454c74"
        />
        <path
          id="Path_49087"
          data-name="Path 49087"
          d="M-14199.71-20010.437l-5.585,2.617-5.586-8.98-3.566-.445,1.661-5.465h4.213l5.223,9.158,2.27-1.137Z"
          transform="translate(15183.536 22929.008)"
          fill="#5a618d"
        />
        <g
          id="Group_12385-2"
          data-name="Group 12385"
          transform="translate(953.605 2847.354)"
        >
          <path
            id="Path_49079-2"
            data-name="Path 49079"
            d="M259.575,256.42,269,251.592l5.748,8.894,10.576.531.531,10.576,8.894,5.748-4.828,9.425,4.828,9.425-8.894,5.748-.531,10.576-10.576.531L269,321.938l-9.425-4.828-9.425,4.828-5.748-8.894-10.576-.531-.531-10.576L224.4,296.19l4.828-9.425-4.828-9.425,8.894-5.748.531-10.576,10.576-.531,5.748-8.894Z"
            transform="translate(-224.402 -251.592)"
            fill="#2c2a43"
          />
          <path
            id="Path_49080-2"
            data-name="Path 49080"
            d="M254.083,255.666l7.953-4.074,4.85,7.505,8.925.448.448,8.925,7.505,4.85-4.074,7.953,4.074,7.953-7.505,4.85L275.812,303l-8.925.448-4.85,7.505-7.953-4.074-7.953,4.074-4.85-7.505L232.355,303l-.448-8.925-7.505-4.85,4.074-7.953L224.4,273.32l7.505-4.85.448-8.925,8.925-.448,4.85-7.505Z"
            transform="translate(-218.91 -246.099)"
            fill="#3a3757"
          />
          <path
            id="Path_49081-2"
            data-name="Path 49081"
            d="M251.9,255.367l7.368-3.775,4.494,6.953,8.268.415.415,8.268,6.953,4.493-3.775,7.368,3.775,7.368-6.953,4.494-.415,8.268-8.268.415-4.494,6.953-7.368-3.775-7.368,3.775-4.494-6.953-8.268-.415-.415-8.268-6.953-4.494,3.775-7.368-3.775-7.368,6.953-4.493.415-8.268,8.268-.415,4.494-6.953Z"
            transform="translate(-216.726 -243.915)"
            fill="#211f33"
          />
        </g>
        <path
          id="Path_49090"
          data-name="Path 49090"
          d="M-2.17-3.41l5.8-5.518c3.007-2.821,3.6-4.743,3.6-6.851,0-3.844-3.038-6.231-7.75-6.231-3.565,0-6.572,1.333-8.246,3.6l2.821,2.17A6.125,6.125,0,0,1-.868-18.507c2.666,0,4.03,1.147,4.03,3.131,0,1.209-.372,2.48-2.48,4.495L-7.936-2.7V0h16V-3.41Z"
          transform="translate(988.528 2893.38)"
          fill="#a2a5d3"
        />
      </g>
      <rect
        id="Rectangle_7360"
        data-name="Rectangle 7360"
        width="181.813"
        height="211.949"
        transform="translate(1278.396 3105.695) rotate(90)"
        fill="url(#linear-gradient-3)"
      />
      <rect
        id="Rectangle_7358"
        data-name="Rectangle 7358"
        width="373.246"
        height="277.261"
        transform="translate(857.627 2914.264) rotate(90)"
        fill="url(#linear-gradient-4)"
      />
      <rect
        id="Rectangle_7354"
        data-name="Rectangle 7354"
        width="281.831"
        height="211.949"
        transform="translate(1068.447 3005.678) rotate(90)"
        fill="url(#linear-gradient-5)"
      />
      <g
        id="Group_12090"
        data-name="Group 12090"
        transform="translate(33.125 -212)"
        opacity="0.505"
      >
        <path
          id="Path_49082"
          data-name="Path 49082"
          d="M-14515.347-19974.176l6.3-6.3-6.3-6.3,4.772-4.773-7.083-7.082"
          transform="matrix(0.891, 0.454, -0.454, 0.891, 4547.895, 27599.146)"
          fill="none"
          stroke="#e8b064"
          stroke-width="3"
        />
        <path
          id="Path_49083"
          data-name="Path 49083"
          d="M1.747,18.5,6.514,13.73,1.747,8.965,5.357,5.355,0,0"
          transform="matrix(-0.602, -0.799, 0.799, -0.602, 720.927, 3223.477)"
          fill="none"
          stroke="#e8b064"
          stroke-width="3"
        />
        <path
          id="Path_49084"
          data-name="Path 49084"
          d="M1.746,0,6.513,4.768,1.747,9.533l3.609,3.61L0,18.5"
          transform="matrix(0.602, -0.799, 0.799, 0.602, 641.383, 3212.344)"
          fill="none"
          stroke="#e8b064"
          stroke-width="3"
        />
      </g>
      <g
        id="Group_12385-3"
        data-name="Group 12385"
        transform="translate(-279.374 167.813)"
      >
        <path
          id="Path_49086-2"
          data-name="Path 49086"
          d="M34.509,72.518,47.876,8.723,28.63,19.293,13.208,0,0,64.113Z"
          transform="translate(1003.304 2993.779) rotate(-173)"
          fill="#463d79"
        />
        <path
          id="Path_49085-2"
          data-name="Path 49085"
          d="M-14438.466-19854.387l13.367,63.795-19.246-10.57-15.422,19.293-13.209-64.113Z"
          transform="translate(17773.521 20865.385) rotate(-7)"
          fill="#39306c"
        />
        <path
          id="Path_49088-2"
          data-name="Path 49088"
          d="M-14195.469-20005.857l6.548-3.1,12.96,6.35,8.593-12.988,5.925-.477-2.108-5.73h-6.542l-7.118,10.3-11.709-5.422-8.765,4.658Z"
          transform="translate(15188 22945)"
          fill="#28214d"
        />
        <path
          id="Path_49087-2"
          data-name="Path 49087"
          d="M-14195.462-20006.9l-7.2,3.373-7.2-11.57-4.595-.572,2.141-7.041h5.427l6.728,11.8,2.924-1.463Z"
          transform="translate(15188 22946)"
          fill="#3e366a"
        />
        <g id="Group_12385-4" data-name="Group 12385">
          <path
            id="Path_49079-3"
            data-name="Path 49079"
            d="M269.714,257.812l12.141-6.22,7.4,11.457,13.625.684.684,13.625,11.457,7.4-6.22,12.141,6.22,12.141-11.457,7.4-.684,13.625-13.625.684-7.4,11.457L269.714,336l-12.141,6.22-7.4-11.457-13.625-.684-.684-13.625-11.457-7.4,6.22-12.141-6.22-12.141,11.457-7.4.684-13.625,13.625-.684,7.4-11.457Z"
            transform="translate(729.203 2595.762)"
            fill="#2c2a43"
          />
          <path
            id="Path_49080-3"
            data-name="Path 49080"
            d="M262.639,256.841l10.246-5.249,6.249,9.668,11.5.577.577,11.5,9.668,6.249-5.249,10.246,5.249,10.246-9.668,6.249-.577,11.5-11.5.577-6.249,9.668-10.246-5.249-10.246,5.249-6.249-9.668-11.5-.577-.577-11.5-9.668-6.249,5.249-10.246L224.4,279.584l9.668-6.249.577-11.5,11.5-.577,6.249-9.668Z"
            transform="translate(736.278 2602.838)"
            fill="#3a3757"
          />
          <path
            id="Path_49081-3"
            data-name="Path 49081"
            d="M259.826,256.455l9.492-4.863,5.789,8.957,10.652.535.535,10.652,8.957,5.789-4.863,9.492,4.863,9.492-8.957,5.789-.535,10.651-10.652.535-5.789,8.957-9.492-4.863-9.492,4.863-5.789-8.957-10.652-.535-.535-10.651-8.957-5.789,4.863-9.492-4.863-9.492,8.957-5.789.535-10.652,10.652-.535,5.789-8.957Z"
            transform="translate(739.091 2605.652)"
            fill="#211f33"
          />
        </g>
        <path
          id="Path_49091"
          data-name="Path 49091"
          d="M-7.3-28v4.36h5.92V0h5.2V-28Z"
          transform="translate(999 2907)"
          fill="#e8b064"
        />
      </g>
      <g
        id="Group_12391"
        data-name="Group 12391"
        transform="translate(-26.66 212.109)"
      >
        <path
          id="Path_49086-3"
          data-name="Path 49086"
          d="M26.788,56.291,37.164,6.771l-14.94,8.205L10.253,0,0,49.767Z"
          transform="translate(992.184 2961.015) rotate(-173)"
          fill="#a2615f"
        />
        <path
          id="Path_49085-3"
          data-name="Path 49085"
          d="M26.787,0,37.164,49.52l-14.94-8.205L10.253,56.29,0,6.523Z"
          transform="translate(980.913 2905.92) rotate(-7)"
          fill="#894b49"
        />
        <path
          id="Path_49088-3"
          data-name="Path 49088"
          d="M-14195.965-20009.426l5.082-2.406,10.061,4.93,6.67-10.082,4.6-.371-1.637-4.447h-5.078l-5.525,8-9.09-4.207-6.8,3.615Z"
          transform="translate(15179.786 22928.029)"
          fill="#773c3a"
        />
        <path
          id="Path_49087-3"
          data-name="Path 49087"
          d="M-14199.71-20010.437l-5.585,2.617-5.586-8.98-3.566-.445,1.661-5.465h4.213l5.223,9.158,2.27-1.137Z"
          transform="translate(15183.536 22929.008)"
          fill="#8d4f4d"
        />
        <g
          id="Group_12385-5"
          data-name="Group 12385"
          transform="translate(953.605 2847.354)"
        >
          <path
            id="Path_49079-4"
            data-name="Path 49079"
            d="M259.575,256.42,269,251.592l5.748,8.894,10.576.531.531,10.576,8.894,5.748-4.828,9.425,4.828,9.425-8.894,5.748-.531,10.576-10.576.531L269,321.938l-9.425-4.828-9.425,4.828-5.748-8.894-10.576-.531-.531-10.576L224.4,296.19l4.828-9.425-4.828-9.425,8.894-5.748.531-10.576,10.576-.531,5.748-8.894Z"
            transform="translate(-224.402 -251.592)"
            fill="#2c2a43"
          />
          <path
            id="Path_49080-4"
            data-name="Path 49080"
            d="M254.083,255.666l7.953-4.074,4.85,7.505,8.925.448.448,8.925,7.505,4.85-4.074,7.953,4.074,7.953-7.505,4.85L275.812,303l-8.925.448-4.85,7.505-7.953-4.074-7.953,4.074-4.85-7.505L232.355,303l-.448-8.925-7.505-4.85,4.074-7.953L224.4,273.32l7.505-4.85.448-8.925,8.925-.448,4.85-7.505Z"
            transform="translate(-218.91 -246.099)"
            fill="#3a3757"
          />
          <path
            id="Path_49081-4"
            data-name="Path 49081"
            d="M251.9,255.367l7.368-3.775,4.494,6.953,8.268.415.415,8.268,6.953,4.493-3.775,7.368,3.775,7.368-6.953,4.494-.415,8.268-8.268.415-4.494,6.953-7.368-3.775-7.368,3.775-4.494-6.953-8.268-.415-.415-8.268-6.953-4.494,3.775-7.368-3.775-7.368,6.953-4.493.415-8.268,8.268-.415,4.494-6.953Z"
            transform="translate(-216.726 -243.915)"
            fill="#211f33"
          />
        </g>
        <path
          id="Path_49092"
          data-name="Path 49092"
          d="M1.581-12.741,6.851-19v-2.7H-7.936v3.379H1.922l-4.929,5.859V-9.7h1.984c3.286,0,4.712,1.271,4.712,3.224,0,2.015-1.7,3.286-4.588,3.286A10.118,10.118,0,0,1-7.254-5.332L-8.99-2.2A13.633,13.633,0,0,0-.837.31C4.991.31,7.75-2.852,7.75-6.51,7.75-9.765,5.673-12.214,1.581-12.741Z"
          transform="translate(988.528 2893.38)"
          fill="#a2615f"
        />
      </g>
      <g
        id="Group_12393"
        data-name="Group 12393"
        transform="translate(182.385 297.145)"
      >
        <g
          id="Group_12385-6"
          data-name="Group 12385"
          transform="translate(953.605 2847.354)"
        >
          <path
            id="Path_49079-5"
            data-name="Path 49079"
            d="M261.514,256.686l9.944-5.094,6.065,9.384,11.159.56.56,11.159,9.384,6.065-5.094,9.944,5.094,9.944-9.384,6.065-.56,11.159-11.159.56-6.065,9.384-9.944-5.094-9.944,5.094-6.065-9.384-11.159-.56-.56-11.159-9.384-6.065L229.5,288.7,224.4,278.76l9.384-6.065.56-11.159,11.159-.56,6.065-9.384Z"
            transform="translate(-224.402 -251.592)"
            fill="#2c2a43"
          />
          <path
            id="Path_49080-5"
            data-name="Path 49080"
            d="M255.719,255.891l8.391-4.3,5.118,7.919,9.417.473.473,9.417,7.919,5.118-4.3,8.391,4.3,8.391-7.919,5.118-.473,9.417-9.417.473-5.118,7.919-8.391-4.3-8.391,4.3-5.118-7.919-9.417-.473-.473-9.417L224.4,291.3l4.3-8.391-4.3-8.391,7.919-5.118.473-9.417,9.417-.473,5.118-7.919Z"
            transform="translate(-218.607 -245.797)"
            fill="#3a3757"
          />
          <path
            id="Path_49081-5"
            data-name="Path 49081"
            d="M253.415,255.575l7.774-3.983,4.741,7.336,8.724.438.438,8.724,7.336,4.741-3.983,7.774,3.983,7.774-7.336,4.741-.438,8.724-8.724.438-4.741,7.336-7.774-3.983-7.774,3.983-4.741-7.336-8.724-.438-.438-8.724-7.336-4.741,3.983-7.774-3.983-7.774,7.336-4.741.438-8.724,8.724-.438,4.741-7.336Z"
            transform="translate(-216.303 -243.492)"
            fill="#211f33"
          />
        </g>
        <path
          id="Path_49093"
          data-name="Path 49093"
          d="M-.957-14.157H-3.168l.495-5.346H7.26v-3.6H-6.3L-7.491-10.527h5.577c4.785,0,6.2,1.386,6.2,3.6C4.29-4.752,2.475-3.4-.594-3.4a10.937,10.937,0,0,1-6.8-2.277L-9.207-2.343A14.44,14.44,0,0,0-.528.33c6.2,0,9.141-3.366,9.141-7.425C8.613-11.187,5.874-14.157-.957-14.157Z"
          transform="translate(990.318 2896.263)"
          fill="#8e72db"
        />
      </g>
      <path
        id="Path_49157"
        data-name="Path 49157"
        d="M5.3-2.64,9.792-6.912c2.328-2.184,2.784-3.672,2.784-5.3,0-2.976-2.352-4.824-6-4.824A7.758,7.758,0,0,0,.192-14.256l2.184,1.68a4.742,4.742,0,0,1,3.936-1.752c2.064,0,3.12.888,3.12,2.424,0,.936-.288,1.92-1.92,3.48L.84-2.088V0H13.224V-2.64ZM29.64-6.456H26.664V-9.84H23.736v3.384h-5.5L26.04-16.8H22.7L14.424-5.976v2.16H23.64V0h3.024V-3.816H29.64ZM33.312.168A1.952,1.952,0,0,0,35.28-1.824a1.923,1.923,0,0,0-1.968-1.992,1.923,1.923,0,0,0-1.968,1.992A1.952,1.952,0,0,0,33.312.168Zm10.7.072c4.008,0,7.032-3.12,7.032-8.64s-3.024-8.64-7.032-8.64c-3.984,0-7.008,3.12-7.008,8.64S40.032.24,44.016.24Zm0-2.712c-2.28,0-3.864-1.872-3.864-5.928s1.584-5.928,3.864-5.928c2.3,0,3.888,1.872,3.888,5.928S46.32-2.472,44.016-2.472ZM60.168.24C64.176.24,67.2-2.88,67.2-8.4s-3.024-8.64-7.032-8.64c-3.984,0-7.008,3.12-7.008,8.64S56.184.24,60.168.24Zm0-2.712c-2.28,0-3.864-1.872-3.864-5.928s1.584-5.928,3.864-5.928c2.3,0,3.888,1.872,3.888,5.928S62.472-2.472,60.168-2.472ZM76.32.24c4.008,0,7.032-3.12,7.032-8.64s-3.024-8.64-7.032-8.64c-3.984,0-7.008,3.12-7.008,8.64S72.336.24,76.32.24Zm0-2.712c-2.28,0-3.864-1.872-3.864-5.928s1.584-5.928,3.864-5.928c2.3,0,3.888,1.872,3.888,5.928S78.624-2.472,76.32-2.472ZM100.992-8.52H97.9c0,3.72-2.016,5.9-6.144,5.9H90.72V-7.7l6.12-3.24V-12.7L90.72-9.48v-1.656l6.12-3.216v-1.776l-6.12,3.24V-16.8H87.648v5.52l-2.52,1.344v1.752l2.52-1.32v1.656l-2.52,1.32v1.776L87.648-6.1V0H91.08C97.656,0,101.016-3.216,100.992-8.52Z"
        transform="translate(669 3219)"
        fill="#e8b064"
      />
      <path
        id="Path_49156"
        data-name="Path 49156"
        d="M.144-12.6v1.962H2.808V0h2.34V-12.6ZM10.836-1.98l3.366-3.2c1.746-1.638,2.088-2.754,2.088-3.978,0-2.232-1.764-3.618-4.5-3.618A5.819,5.819,0,0,0,7-10.692L8.64-9.432a3.556,3.556,0,0,1,2.952-1.314c1.548,0,2.34.666,2.34,1.818,0,.7-.216,1.44-1.44,2.61l-5,4.752V0h9.288V-1.98ZM19.71.126a1.464,1.464,0,0,0,1.476-1.494A1.442,1.442,0,0,0,19.71-2.862a1.442,1.442,0,0,0-1.476,1.494A1.464,1.464,0,0,0,19.71.126ZM27.738.18c3.006,0,5.274-2.34,5.274-6.48s-2.268-6.48-5.274-6.48c-2.988,0-5.256,2.34-5.256,6.48S24.75.18,27.738.18Zm0-2.034c-1.71,0-2.9-1.4-2.9-4.446s1.188-4.446,2.9-4.446c1.728,0,2.916,1.4,2.916,4.446S29.466-1.854,27.738-1.854ZM39.852.18c3.006,0,5.274-2.34,5.274-6.48s-2.268-6.48-5.274-6.48c-2.988,0-5.256,2.34-5.256,6.48S36.864.18,39.852.18Zm0-2.034c-1.71,0-2.9-1.4-2.9-4.446s1.188-4.446,2.9-4.446c1.728,0,2.916,1.4,2.916,4.446S41.58-1.854,39.852-1.854ZM51.966.18c3.006,0,5.274-2.34,5.274-6.48s-2.268-6.48-5.274-6.48c-2.988,0-5.256,2.34-5.256,6.48S48.978.18,51.966.18Zm0-2.034c-1.71,0-2.9-1.4-2.9-4.446s1.188-4.446,2.9-4.446c1.728,0,2.916,1.4,2.916,4.446S53.694-1.854,51.966-1.854ZM70.47-6.39H68.148c0,2.79-1.512,4.428-4.608,4.428h-.774V-5.778l4.59-2.43V-9.522L62.766-7.11V-8.352l4.59-2.412V-12.1l-4.59,2.43V-12.6h-2.3v4.14l-1.89,1.008v1.314l1.89-.99v1.242l-1.89.99v1.332l1.89-1.008V0h2.574C67.968,0,70.488-2.412,70.47-6.39Z"
        transform="translate(443 3221)"
        fill="#a2a5d3"
      />
      <path
        id="Path_49158"
        data-name="Path 49158"
        d="M6.516-7.776A4.3,4.3,0,0,0,3.15-6.462V-6.48c0-2.862,1.494-4.338,3.87-4.338a4.285,4.285,0,0,1,2.394.612l.864-1.764a6.316,6.316,0,0,0-3.312-.81C3.312-12.78.792-10.4.792-6.084.792-2.034,2.808.18,6.246.18,8.82.18,10.854-1.4,10.854-3.906,10.854-6.264,9-7.776,6.516-7.776Zm-.4,6.12c-1.674,0-2.61-.936-2.61-2.124A2.292,2.292,0,0,1,6.066-5.94c1.53,0,2.52.828,2.52,2.142A2.187,2.187,0,0,1,6.12-1.656ZM13.662.126a1.464,1.464,0,0,0,1.476-1.494,1.442,1.442,0,0,0-1.476-1.494,1.442,1.442,0,0,0-1.476,1.494A1.464,1.464,0,0,0,13.662.126ZM21.69.18c3.006,0,5.274-2.34,5.274-6.48S24.7-12.78,21.69-12.78c-2.988,0-5.256,2.34-5.256,6.48S18.7.18,21.69.18Zm0-2.034c-1.71,0-2.9-1.4-2.9-4.446s1.188-4.446,2.9-4.446c1.728,0,2.916,1.4,2.916,4.446S23.418-1.854,21.69-1.854ZM33.8.18c3.006,0,5.274-2.34,5.274-6.48S36.81-12.78,33.8-12.78c-2.988,0-5.256,2.34-5.256,6.48S30.816.18,33.8.18Zm0-2.034c-1.71,0-2.9-1.4-2.9-4.446s1.188-4.446,2.9-4.446c1.728,0,2.916,1.4,2.916,4.446S35.532-1.854,33.8-1.854ZM45.918.18c3.006,0,5.274-2.34,5.274-6.48s-2.268-6.48-5.274-6.48c-2.988,0-5.256,2.34-5.256,6.48S42.93.18,45.918.18Zm0-2.034c-1.71,0-2.9-1.4-2.9-4.446s1.188-4.446,2.9-4.446c1.728,0,2.916,1.4,2.916,4.446S47.646-1.854,45.918-1.854Zm18.5-4.536H62.1c0,2.79-1.512,4.428-4.608,4.428h-.774V-5.778l4.59-2.43V-9.522L56.718-7.11V-8.352l4.59-2.412V-12.1l-4.59,2.43V-12.6h-2.3v4.14l-1.89,1.008v1.314l1.89-.99v1.242l-1.89.99v1.332l1.89-1.008V0h2.574C61.92,0,64.44-2.412,64.422-6.39Z"
        transform="translate(930 3217)"
        fill="#a2615f"
      />
      <path
        id="Path_49159"
        data-name="Path 49159"
        d="M5.472-6.576l2.72-3.232V-11.2H.56v1.744H5.648L3.1-6.432v1.424H4.128c1.7,0,2.432.656,2.432,1.664,0,1.04-.88,1.7-2.368,1.7a5.222,5.222,0,0,1-3.28-1.1l-.9,1.616A7.036,7.036,0,0,0,4.224.16c3.008,0,4.432-1.632,4.432-3.52C8.656-5.04,7.584-6.3,5.472-6.576ZM11.264.112a1.3,1.3,0,0,0,1.312-1.328,1.282,1.282,0,0,0-1.312-1.328A1.282,1.282,0,0,0,9.952-1.216,1.3,1.3,0,0,0,11.264.112ZM18.4.16c2.672,0,4.688-2.08,4.688-5.76s-2.016-5.76-4.688-5.76c-2.656,0-4.672,2.08-4.672,5.76S15.744.16,18.4.16Zm0-1.808c-1.52,0-2.576-1.248-2.576-3.952S16.88-9.552,18.4-9.552c1.536,0,2.592,1.248,2.592,3.952S19.936-1.648,18.4-1.648ZM29.168.16c2.672,0,4.688-2.08,4.688-5.76s-2.016-5.76-4.688-5.76c-2.656,0-4.672,2.08-4.672,5.76S26.512.16,29.168.16Zm0-1.808c-1.52,0-2.576-1.248-2.576-3.952s1.056-3.952,2.576-3.952C30.7-9.552,31.76-8.3,31.76-5.6S30.7-1.648,29.168-1.648ZM39.936.16c2.672,0,4.688-2.08,4.688-5.76s-2.016-5.76-4.688-5.76c-2.656,0-4.672,2.08-4.672,5.76S37.28.16,39.936.16Zm0-1.808c-1.52,0-2.576-1.248-2.576-3.952s1.056-3.952,2.576-3.952c1.536,0,2.592,1.248,2.592,3.952S41.472-1.648,39.936-1.648ZM56.384-5.68H54.32c0,2.48-1.344,3.936-4.1,3.936h-.688V-5.136l4.08-2.16V-8.464L49.536-6.32v-1.1l4.08-2.144v-1.184l-4.08,2.16V-11.2H47.488v3.68l-1.68.9v1.168l1.68-.88v1.1l-1.68.88v1.184l1.68-.9V0h2.288C54.16,0,56.4-2.144,56.384-5.68Z"
        transform="translate(1145 3249)"
        fill="#8e72db"
      />
      <path
        id="Path_49155"
        data-name="Path 49155"
        d="M10.688-4.3H8.7V-6.56H6.752V-4.3H3.088l5.2-6.9H6.064L.544-3.984v1.44H6.688V0H8.7V-2.544h1.984ZM13.136.112a1.3,1.3,0,0,0,1.312-1.328,1.282,1.282,0,0,0-1.312-1.328,1.282,1.282,0,0,0-1.312,1.328A1.3,1.3,0,0,0,13.136.112ZM20.272.16c2.672,0,4.688-2.08,4.688-5.76s-2.016-5.76-4.688-5.76c-2.656,0-4.672,2.08-4.672,5.76S17.616.16,20.272.16Zm0-1.808C18.752-1.648,17.7-2.9,17.7-5.6s1.056-3.952,2.576-3.952c1.536,0,2.592,1.248,2.592,3.952S21.808-1.648,20.272-1.648ZM31.04.16c2.672,0,4.688-2.08,4.688-5.76s-2.016-5.76-4.688-5.76c-2.656,0-4.672,2.08-4.672,5.76S28.384.16,31.04.16Zm0-1.808c-1.52,0-2.576-1.248-2.576-3.952S29.52-9.552,31.04-9.552c1.536,0,2.592,1.248,2.592,3.952S32.576-1.648,31.04-1.648ZM41.808.16C44.48.16,46.5-1.92,46.5-5.6s-2.016-5.76-4.688-5.76c-2.656,0-4.672,2.08-4.672,5.76S39.152.16,41.808.16Zm0-1.808c-1.52,0-2.576-1.248-2.576-3.952s1.056-3.952,2.576-3.952C43.344-9.552,44.4-8.3,44.4-5.6S43.344-1.648,41.808-1.648ZM58.256-5.68H56.192c0,2.48-1.344,3.936-4.1,3.936h-.688V-5.136l4.08-2.16V-8.464L51.408-6.32v-1.1l4.08-2.144v-1.184l-4.08,2.16V-11.2H49.36v3.68l-1.68.9v1.168l1.68-.88v1.1l-1.68.88v1.184l1.68-.9V0h2.288C56.032,0,58.272-2.144,58.256-5.68Z"
        transform="translate(234 3249)"
        fill="#718d6f"
      />
    </g>
  </svg>
);

export const CodeEditor = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="677.256"
    height="497"
    viewBox="0 0 677.256 497"
  >
    <g
      id="Group_12044"
      data-name="Group 12044"
      transform="translate(-383.744 -170)"
    >
      <g
        id="Rectangle_7018"
        data-name="Rectangle 7018"
        transform="translate(1061 170) rotate(90)"
        fill="#161622"
        stroke="#223"
        strokeWidth="1"
      >
        <rect className="code-bg" width="497" height="677.256" stroke="none" />
      </g>
      <circle
        id="Ellipse_2"
        data-name="Ellipse 2"
        cx="7"
        cy="7"
        r="7"
        transform="translate(417 204)"
        fill="#ff7c7c"
        className="code-animated-ellipsis"
      />
      <circle
        id="Ellipse_3"
        data-name="Ellipse 3"
        cx="7"
        cy="7"
        r="7"
        transform="translate(441 204)"
        fill="#fff07c"
        className="code-animated-ellipsis"
      />
      <circle
        id="Ellipse_4"
        data-name="Ellipse 4"
        cx="7"
        cy="7"
        r="7"
        transform="translate(465 204)"
        fill="#90ff7c"
        className="code-animated-ellipsis"
      />
      <rect
        id="Rectangle_6939"
        data-name="Rectangle 6939"
        width="250"
        height="9"
        rx="4.5"
        transform="translate(417 260)"
        fill="#5346bf"
        className="code-animated"
      />
      <rect
        id="Rectangle_6938"
        data-name="Rectangle 6938"
        width="352"
        height="9"
        rx="4.5"
        transform="translate(417 296)"
        fill="#252538"
        className="code-animated"
      />
      <rect
        id="Rectangle_5079"
        data-name="Rectangle 5079"
        width="427"
        height="9"
        rx="4.5"
        transform="translate(417 332)"
        fill="#252538"
        className="code-animated"
      />
      <rect
        id="Rectangle_5080"
        data-name="Rectangle 5080"
        width="250"
        height="9"
        rx="4.5"
        transform="translate(417 368)"
        fill="#252538"
        className="code-animated"
      />
      <rect
        id="Rectangle_5081"
        data-name="Rectangle 5081"
        width="285"
        height="9"
        rx="4.5"
        transform="translate(417 404)"
        fill="#252538"
        className="code-animated"
      />
      <rect
        id="Rectangle_5082"
        data-name="Rectangle 5082"
        width="150"
        height="9"
        rx="4.5"
        transform="translate(417 440)"
        fill="#953c9a"
        className="code-animated"
      />
      <rect
        id="Rectangle_5083"
        data-name="Rectangle 5083"
        width="300"
        height="9"
        rx="4.5"
        transform="translate(417 476)"
        fill="#252538"
        className="code-animated"
      />
      <rect
        id="Rectangle_5086"
        data-name="Rectangle 5086"
        width="285"
        height="9"
        rx="4.5"
        transform="translate(417 512)"
        fill="#252538"
        className="code-animated"
      />
      <rect
        id="Rectangle_5085"
        data-name="Rectangle 5085"
        width="150"
        height="9"
        rx="4.5"
        transform="translate(417 548)"
        fill="#bc5b52"
        className="code-animated"
      />
      <rect
        id="Rectangle_5084"
        data-name="Rectangle 5084"
        width="300"
        height="9"
        rx="4.5"
        transform="translate(417 584)"
        fill="#252538"
        className="code-animated"
      />
    </g>
  </svg>
);

export const Logo = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="58"
    height="76.48"
    viewBox="0 0 58 76.48"
  >
    <path
      d="M-7453.842,21792.887a28.571,28.571,0,0,1-5.444-1.7,29.084,29.084,0,0,1-4.927-2.687,29.264,29.264,0,0,1-4.291-3.562,29.447,29.447,0,0,1-3.542-4.316,29.336,29.336,0,0,1-2.673-4.953,29.181,29.181,0,0,1-1.69-5.473,29.633,29.633,0,0,1-.588-5.879,29.248,29.248,0,0,1,1.632-9.672,29.036,29.036,0,0,1,4.525-8.3l1,.863c-.389.5-.764,1.02-1.115,1.539a27.981,27.981,0,0,0-2.551,4.73,27.832,27.832,0,0,0-1.612,5.223,28.128,28.128,0,0,0-.562,5.613,28.06,28.06,0,0,0,.562,5.609,27.655,27.655,0,0,0,1.612,5.223,27.832,27.832,0,0,0,2.551,4.73,27.789,27.789,0,0,0,3.382,4.117,27.465,27.465,0,0,0,4.1,3.4,27.594,27.594,0,0,0,4.7,2.566,27.364,27.364,0,0,0,5.193,1.621,27.794,27.794,0,0,0,5.581.566,27.781,27.781,0,0,0,5.581-.566,27.342,27.342,0,0,0,5.193-1.621,27.4,27.4,0,0,0,4.7-2.566,27.705,27.705,0,0,0,4.1-3.4,27.567,27.567,0,0,0,3.38-4.117,27.815,27.815,0,0,0,2.553-4.73,27.743,27.743,0,0,0,1.612-5.223,28.1,28.1,0,0,0,.563-5.609,28.165,28.165,0,0,0-.563-5.613,27.724,27.724,0,0,0-1.612-5.223,27.964,27.964,0,0,0-2.553-4.73c-.355-.527-.733-1.051-1.125-1.555l1-.863a29.1,29.1,0,0,1,4.532,8.3,29.226,29.226,0,0,1,1.637,9.68,29.634,29.634,0,0,1-.59,5.879,29.145,29.145,0,0,1-1.69,5.473,29.267,29.267,0,0,1-2.673,4.953,29.406,29.406,0,0,1-3.541,4.316,29.4,29.4,0,0,1-4.292,3.563,29.1,29.1,0,0,1-4.925,2.688,28.625,28.625,0,0,1-5.444,1.7,28.927,28.927,0,0,1-5.845.594A28.911,28.911,0,0,1-7453.842,21792.887Zm.532-2.6a25.792,25.792,0,0,1-4.949-1.547,26.336,26.336,0,0,1-4.479-2.445,26.616,26.616,0,0,1-3.9-3.234,26.654,26.654,0,0,1-3.219-3.926,26.527,26.527,0,0,1-2.43-4.5,26.253,26.253,0,0,1-1.538-4.977,26.862,26.862,0,0,1-.534-5.34,26.59,26.59,0,0,1,1.463-8.734,26.487,26.487,0,0,1,4.061-7.508l1,.863c-.319.418-.633.852-.932,1.3a25.325,25.325,0,0,0-2.309,4.277,25.37,25.37,0,0,0-1.459,4.727,25.533,25.533,0,0,0-.508,5.078,25.562,25.562,0,0,0,.508,5.078,25.331,25.331,0,0,0,1.459,4.723,25.051,25.051,0,0,0,2.309,4.277,25.494,25.494,0,0,0,3.06,3.73,24.983,24.983,0,0,0,3.707,3.074,24.951,24.951,0,0,0,4.253,2.324,24.958,24.958,0,0,0,4.7,1.469,25.408,25.408,0,0,0,5.047.508,25.442,25.442,0,0,0,5.049-.508,24.952,24.952,0,0,0,4.7-1.469,24.738,24.738,0,0,0,4.254-2.324,25.247,25.247,0,0,0,3.708-3.074,25.572,25.572,0,0,0,3.058-3.73,25.051,25.051,0,0,0,2.309-4.277,25.114,25.114,0,0,0,1.459-4.723,25.446,25.446,0,0,0,.508-5.078,25.417,25.417,0,0,0-.508-5.078,25.083,25.083,0,0,0-1.459-4.727,25.221,25.221,0,0,0-2.309-4.277c-.3-.441-.613-.883-.943-1.312l1-.863a26.465,26.465,0,0,1,4.069,7.516,26.583,26.583,0,0,1,1.466,8.742,26.863,26.863,0,0,1-.536,5.34,26.445,26.445,0,0,1-1.537,4.977,26.493,26.493,0,0,1-2.43,4.5,26.527,26.527,0,0,1-3.219,3.926,26.325,26.325,0,0,1-3.9,3.234,26.2,26.2,0,0,1-4.478,2.445,25.787,25.787,0,0,1-4.949,1.547,26.557,26.557,0,0,1-5.313.539A26.55,26.55,0,0,1-7453.31,21790.289Zm.841-5.43a2.119,2.119,0,0,1,1.45-2.016v-10.3l-2.592-1.5v7.559a2.123,2.123,0,0,1,1.451,2.016,2.115,2.115,0,0,1-2.11,2.121,2.114,2.114,0,0,1-2.107-2.121,2.121,2.121,0,0,1,1.45-2.016v-8.316l-3.816-2.2v-.387l.16-28.527-5.517-3.344h-6.623v5.793l8.8,5.141-.662,1.145-9.452-5.523v-7.883h8.308l.156.1,6.316,3.828v.375l-.16,28.516,9.167,5.285,8.919-5.277v-28.9l.315-.2,6.092-3.73h8.287v7.895l-.342.188-9.68,5.332-.633-1.164,9.336-5.141v-5.781h-6.6l-5.459,3.34v28.914l-.325.191-3.757,2.223v8.1a2.118,2.118,0,0,1,1.481,2.023,2.116,2.116,0,0,1-2.11,2.121,2.114,2.114,0,0,1-2.108-2.121,2.116,2.116,0,0,1,1.419-2v-7.34l-2.592,1.535v2.141a2.12,2.12,0,0,1,1.451,2.016,2.118,2.118,0,0,1-2.11,2.121,2.116,2.116,0,0,1-2.107-2.121,2.118,2.118,0,0,1,1.448-2.016v-1.359l-.918.543-.332-.191-1.121-.645v9.547a2.12,2.12,0,0,1,1.45,2.016,2.116,2.116,0,0,1-2.11,2.121A2.115,2.115,0,0,1-7452.469,21784.859Zm1.319,0a.8.8,0,0,0,.791.8.8.8,0,0,0,.791-.8.79.79,0,0,0-.791-.793A.79.79,0,0,0-7451.15,21784.859Zm7.631-4.242a.793.793,0,0,0,.791.793.792.792,0,0,0,.79-.793.8.8,0,0,0-.79-.8A.8.8,0,0,0-7443.519,21780.617Zm-11.542,0a.793.793,0,0,0,.79.793.793.793,0,0,0,.792-.793.8.8,0,0,0-.792-.8A.8.8,0,0,0-7455.061,21780.617Zm7.6-3.652a.792.792,0,0,0,.79.793.792.792,0,0,0,.792-.793.793.793,0,0,0-.792-.8A.793.793,0,0,0-7447.459,21776.965Zm3.078-12.66v-8.035h-8.237v8.035h-1.78v-15.738h1.78v5.914h8.237v-5.914h1.781v15.738Zm-2.957-21.238v-9.332l.322-.2,3.552-2.125v-3.934a2.126,2.126,0,0,1-1.395-2,2.119,2.119,0,0,1,2.11-2.125,2.117,2.117,0,0,1,2.108,2.125,2.122,2.122,0,0,1-1.505,2.031v3.113l2.557-1.527v-7.93a2.119,2.119,0,0,1-1.578-2.055,2.115,2.115,0,0,1,2.11-2.117,2.113,2.113,0,0,1,2.108,2.117,2.117,2.117,0,0,1-1.321,1.969v8.77l-.323.191-7.427,4.441v8.578Zm3.8-17.582a.792.792,0,0,0,.791.793.793.793,0,0,0,.79-.793.794.794,0,0,0-.79-.8A.793.793,0,0,0-7443.54,21725.484Zm3.691-6.367a.793.793,0,0,0,.791.8.794.794,0,0,0,.79-.8.793.793,0,0,0-.79-.793A.792.792,0,0,0-7439.849,21719.117Zm-11.205,23.949v-8.578l-7.75-4.633v-8.77a2.118,2.118,0,0,1-1.32-1.969,2.114,2.114,0,0,1,2.108-2.117,2.114,2.114,0,0,1,2.109,2.117,2.119,2.119,0,0,1-1.578,2.055v7.93l2.557,1.527v-3.113a2.122,2.122,0,0,1-1.505-2.031,2.117,2.117,0,0,1,2.108-2.125,2.119,2.119,0,0,1,2.109,2.125,2.125,2.125,0,0,1-1.4,2v3.934l3.875,2.32v9.332Zm-4.062-17.582a.792.792,0,0,0,.791.793.792.792,0,0,0,.79-.793.793.793,0,0,0-.79-.8A.793.793,0,0,0-7455.116,21725.484Zm-3.691-6.367a.794.794,0,0,0,.791.8.793.793,0,0,0,.791-.8.792.792,0,0,0-.791-.793A.793.793,0,0,0-7458.807,21719.117Zm15.343,23.906v-7.117l.343-.187,7.405-4.062v-6.527a2.125,2.125,0,0,1-1.5-2.031,2.116,2.116,0,0,1,2.11-2.121,2.116,2.116,0,0,1,2.11,2.121,2.119,2.119,0,0,1-1.4,2v7.348l-.343.191-7.407,4.059v6.332Zm7.57-19.926a.792.792,0,0,0,.791.793.793.793,0,0,0,.791-.793.794.794,0,0,0-.791-.8A.793.793,0,0,0-7435.894,21723.1Zm-19.034,19.926v-6.332l-7.75-4.25v-7.348a2.118,2.118,0,0,1-1.4-2,2.115,2.115,0,0,1,2.109-2.121,2.116,2.116,0,0,1,2.11,2.121,2.124,2.124,0,0,1-1.5,2.031v6.527l7.749,4.25v7.117Zm-7.833-19.926a.793.793,0,0,0,.791.793.792.792,0,0,0,.791-.793.793.793,0,0,0-.791-.8A.794.794,0,0,0-7462.761,21723.1Z"
      transform="translate(7476.998 -21717)"
      fill="#fff"
    />
  </svg>
);
